// utils/currency.js

/**
 * Hardcoded mapping of hospital ID → currency
 */
export const hospitalCurrencyMap = {
  "68306098776144597cc2a7d8": "PKR", // Darul Sehat Hospital – Pakistan
  "6776b0e23be2e32f7c2704d4": "PKR", // Liaquat National – Pakistan
  "68d68a07d3f9b7819cd05e80": "USD", // Advanced Eye Hospital – Denton, USA
};

/**
 * Format any amount in a given currency
 */
export function formatCurrency(amount, currency = "PKR") {
  if (!amount) amount = 0;

  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  }).format(amount);
}

/**
 * Format amount based on hospital ID
 */
export function formatHospitalCurrency(amount, hospitalId) {
  const currency = hospitalCurrencyMap[hospitalId] || "PKR"; // default PKR
  return formatCurrency(amount, currency);
}

// // Detect user currency by IP
// export async function getUserCurrency() {
//   try {
//     const res = await fetch("https://ipwhois.app/json/");
//     const data = await res.json();

//     return {
//       currency: data.currency_code || "PKR", // e.g. "USD", "GBP", "PKR"
//       country: data.country || "Pakistan",
//     };
//   } catch (e) {
//     console.error("IP Lookup failed:", e);
//     return { currency: "PKR", country: "Pakistan" }; // fallback
//   }
// }

// // Format any amount in detected currency
// export function formatCurrency(amount, currency = "USD") {
//   return new Intl.NumberFormat(undefined, {
//     style: "currency",
//     currency,
//   }).format(amount);
// }
